import {RouterModule, Routes} from '@angular/router';
import {PatientGridComponent} from './components/patient-grid.component';
import {PatientCrudComponent} from './components/patient-crud.component';
import {permission} from './patient.permission';

const APP_ROUTES: Routes = [
  {
    path: 'module/patient/grid',
    component: PatientGridComponent,
    canActivate: ['CoreGuard'],
    data: {
      needsLogin: true,
      needsPermissions: [
        permission.MYMEDAX_PATIENT_READ,
        permission.MYMEDAX_PATIENT_DELETE
      ]
    }
  },
  {
    path: 'module/patient/crud/new',
    component: PatientCrudComponent,
    canActivate: ['CoreGuard'],
    data: {
      needsLogin: true,
      needsPermissions: [
        permission.MYMEDAX_PATIENT_CREATE,
        permission.MYMEDAX_PATIENT_UPDATE,
        permission.MYMEDAX_PATIENT_QUESTIONNAIRE_READ,
        permission.MYMEDAX_PATIENT_QUESTIONNAIRE_ASSIGN,
        permission.MYMEDAX_PATIENT_QUESTIONNAIRE_UNASSIGN
      ]
    }
  },
  {
    path: 'module/patient/crud/new/anonymous',
    component: PatientCrudComponent,
    canActivate: ['CoreGuard'],
    data: {
      needsLogin: true,
      needsPermissions: [
        permission.MYMEDAX_PATIENT_CREATE,
        permission.MYMEDAX_PATIENT_UPDATE,
        permission.MYMEDAX_PATIENT_QUESTIONNAIRE_READ,
        permission.MYMEDAX_PATIENT_QUESTIONNAIRE_ASSIGN,
        permission.MYMEDAX_PATIENT_QUESTIONNAIRE_UNASSIGN
      ],
      needsConfig: [
        'feature.patient.anonymous'
      ]
    }
  },
  {
    path: 'module/patient/crud/new/pseudonymous',
    component: PatientCrudComponent,
    canActivate: ['CoreGuard'],
    data: {
      needsLogin: true,
      needsPermissions: [
        permission.MYMEDAX_PATIENT_CREATE,
        permission.MYMEDAX_PATIENT_UPDATE,
        permission.MYMEDAX_PATIENT_QUESTIONNAIRE_READ,
        permission.MYMEDAX_PATIENT_QUESTIONNAIRE_ASSIGN,
        permission.MYMEDAX_PATIENT_QUESTIONNAIRE_UNASSIGN
      ],
      needsConfig: [
        'feature.patient.anonymous'
      ]
    }
  },
  {
    path: 'module/patient/crud/:id',
    component: PatientCrudComponent,
    canActivate: ['CoreGuard'],
    data: {
      needsLogin: true,
      needsPermissions: [
        permission.MYMEDAX_PATIENT_UPDATE,
        permission.MYMEDAX_PATIENT_QUESTIONNAIRE_READ,
        permission.MYMEDAX_PATIENT_QUESTIONNAIRE_ASSIGN,
        permission.MYMEDAX_PATIENT_QUESTIONNAIRE_UNASSIGN
      ]
    }
  },
  {
    path: 'module/patient/assign/:id',
    component: PatientCrudComponent,
    canActivate: ['CoreGuard'],
    data: {
      needsLogin: true,
      needsPermissions: [
        permission.MYMEDAX_PATIENT_UPDATE,
        permission.MYMEDAX_PATIENT_QUESTIONNAIRE_READ,
        permission.MYMEDAX_PATIENT_QUESTIONNAIRE_ASSIGN,
        permission.MYMEDAX_PATIENT_QUESTIONNAIRE_UNASSIGN
      ]
    }
  }
];

export const routing = RouterModule.forRoot(APP_ROUTES);
